// MyFormModal.js

import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { addAddress } from "../../network/api/user.js";
const AddAddressForm = ({ showModal, handleClose, setRefreshComponent, setshowModal }) => {
  const [formData, setFormData] = useState({
    fullName: "",
    mobileNumber: "",
    city: "",
    area: "",
    address: "",
    house: "",
  });

  const [success, setSuccess] = useState("")
  const [fail, setfail] = useState("")
  const [errors, setErrors] = useState({});
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };
  const validateForm = () => {
    const newErrors = {};

    // Check for empty fields
    Object.keys(formData).forEach((key) => {
      if (!formData[key]) {
        newErrors[key] = "This field is required";
      }

      // Additional validation for the "house" field
      if (key === "house") {
        const isNumeric = !isNaN(formData[key]);
        const hasCorrectLength = formData[key].length === 3;

        if (!isNumeric || !hasCorrectLength) {
          newErrors[key] = "House must be a number with a length of 3";
        }
      }
      // Additional validation for the "address" field
      if (key === "address") {
        const containsLettersAndNumbers =
          /[a-zA-Z]/.test(formData[key]) && /\d/.test(formData[key]);
        const hasMinimumLength = formData[key].length >= 5;

        if (!containsLettersAndNumbers || !hasMinimumLength) {
          newErrors[key] =
            "Address must contain both letters and numbers and have a minimum length of 5";
        }
      }
      if (key === "fullName") {
        const hasMinimumLength = formData[key].length >= 4;

        if (!hasMinimumLength) {
          newErrors[key] = "Full Name must have a minimum length of 4";
        }
      }
      // Additional validation for the "area" and "city" fields
      if (key === "area" || key === "city") {
        const isString = typeof formData[key] === "string";
        const hasMinimumLength = formData[key].length >= 4;
        const containsOnlyLetters = /^[a-zA-Z]+$/.test(formData[key]);

        if (!isString || !hasMinimumLength || !containsOnlyLetters) {
          newErrors[key] =
            "This field must be a string with a minimum length of 4 and contain only letters";
        }
      }
    });

    setErrors(newErrors);

    // Return true if there are no errors
    return Object.keys(newErrors).length === 0;
  };
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      // Handle form submission logic here

      await addAddress(formData)
        .then((response) => {
          setSuccess(response.data.message)
          setTimeout(() => {
            setSuccess("")
            handleClose();
            setRefreshComponent((prev) => !prev)
          }, 2000);

        })
        .catch((err) => {
          setfail(err.message)
          setTimeout(() => {
            setfail("")
          }, 2000);
        });
      // Close the modal after form submission
    }
  };

  return (
    <Modal show={showModal} onHide={handleClose} dialogClassName="modal-lg">
      <Modal.Body>
        <div className="frame-420-header d-flex justify-content-between  align-items-center px-2">
          <div>
            <h4>اضف عنوانك</h4>
            <p>يرجى إضافة  موقعك لمساعدتنا في التوصيل بشكل أسرع إلى باب منزلك</p>
          </div>
          <button onClick={() => setshowModal(prev => !prev)}>
            <svg width="40" height="40" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M2.19526 3.13807C1.93491 2.87772 1.93491 2.45561 2.19526 2.19526C2.45562 1.93491 2.87772 1.93491 3.13807 2.19526L5.99999 5.05718L8.86189 2.19526C9.12225 1.93491 9.54438 1.93491 9.80473 2.19526C10.0651 2.45561 10.0651 2.87772 9.80473 3.13807L6.94279 5.99999L9.80473 8.86189C10.0651 9.12225 10.0651 9.54438 9.80473 9.80473C9.54438 10.0651 9.12225 10.0651 8.86189 9.80473L5.99999 6.94279L3.13807 9.80473C2.87772 10.0651 2.45562 10.0651 2.19526 9.80473C1.93491 9.54438 1.93491 9.12225 2.19526 8.86189L5.05718 5.99999L2.19526 3.13807Z" fill="#A5A5A5" />
            </svg>  
          </button>
        </div>
        <div className="frame-420">
          <Form onSubmit={handleSubmit}>
            <Form.Group controlId="formFullName">
              <Form.Label>Full Name</Form.Label>
              <input
                type="text"
                placeholder="Enter your full name"
                name="fullName"
                value={formData.fullName}
                onChange={handleInputChange}
                style={{ width: "100%" }}
              />
              {errors.fullName && (
                <p style={{ color: "red" }}>{errors.fullName}</p>
              )}
            </Form.Group>

            <Form.Group controlId="formMobileNumber">
              <Form.Label>Mobile Number</Form.Label>
              <input
                style={{ width: "100%" }}
                type="text"
                placeholder="Enter your mobile number"
                name="mobileNumber"
                value={formData.mobileNumber}
                onChange={handleInputChange}
              />
              {errors.mobileNumber && (
                <p style={{ color: "red" }}>{errors.mobileNumber}</p>
              )}
            </Form.Group>

            <Form.Group controlId="formCity">
              <Form.Label>City</Form.Label>
              <input
                style={{ width: "100%" }}
                type="text"
                placeholder="Enter your city"
                name="city"
                value={formData.city}
                onChange={handleInputChange}
              />
              {errors.city && <p style={{ color: "red" }}>{errors.city}</p>}
            </Form.Group>

            <Form.Group controlId="formArea">
              <Form.Label>Area</Form.Label>
              <input
                style={{ width: "100%" }}
                type="text"
                placeholder="Enter your area"
                name="area"
                value={formData.area}
                onChange={handleInputChange}
              />
              {errors.area && <p style={{ color: "red" }}>{errors.area}</p>}
            </Form.Group>

            <Form.Group controlId="formAddress">
              <Form.Label>Address</Form.Label>
              <input
                style={{ width: "100%" }}
                type="text"
                placeholder="Enter your address"
                name="address"
                value={formData.address}
                onChange={handleInputChange}
              />
              {errors.address && (
                <p style={{ color: "red" }}>{errors.address}</p>
              )}
            </Form.Group>

            <Form.Group controlId="formHouse">
              <Form.Label>House</Form.Label>
              <input
                style={{ width: "100%" }}
                type="text"
                placeholder="Enter your house number"
                name="house"
                value={formData.house}
                onChange={handleInputChange}
              />
              {errors.house && <p style={{ color: "red" }}>{errors.house}</p>}
            </Form.Group>
            {/* Bootstrap Success Toast */}
            {success && (
              <div className="alert alert-success mt-1" role="alert">
                {success}
              </div>
            )}

            {/* Bootstrap Error Toast */}
            {fail && (
              <div className="alert alert-danger mt-1" role="alert">
                {fail}
              </div>
            )}
            <div className="d-flex justify-content-center mt-3">
              {!success && <Button
                className="w-100 fs-5 "
                style={{ backgroundColor: "#C99700", height: '56px' }}
                type="submit"
              >
                Submit
              </Button>}

            </div>
          </Form>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default React.memo(AddAddressForm);